var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/ugc-tile-macro.j2"] = require( "macros/ugc-tile-macro.j2" );
dependencies["contentful/pdp-ugc-banner.j2"] = require( "contentful/pdp-ugc-banner.j2" );
dependencies["contentful/ugc-filters.j2"] = require( "contentful/ugc-filters.j2" );
dependencies["contentful/ugc-tray.j2"] = require( "contentful/ugc-tray.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-pdp-row-module-content.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/ugc-tile-macro.j2", false, "core/templates/contentful/ugc-pdp-row-module-content.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayUgcTile")) {
var t_4 = t_1.displayUgcTile;
} else {
cb(new Error("cannot import 'displayUgcTile'")); return;
}
context.setVariable("displayUgcTile", t_4);
output += "\n\n<div class=\"dom-ugc js-ugc\" data-qa-ugc=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\" data-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "multipleIndex"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((lineno = 2, colno = 97, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga_inview"), "ga_inview", context, ["PAGE_TYPE","ugc_viewed","UGC PDP",{"dy_noninteraction": 1}])), env.opts.autoescape);
output += ">\n\n    ";
env.getTemplate("contentful/pdp-ugc-banner.j2", false, "core/templates/contentful/ugc-pdp-row-module-content.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    ";
var t_9;
t_9 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"displayHearts");
frame.set("displayHearts", t_9, true);
if(frame.topLevel) {
context.setVariable("displayHearts", t_9);
}
if(frame.topLevel) {
context.addExport("displayHearts", t_9);
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "category")) {
output += "\n        ";
var t_10;
t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug");
frame.set("navigationId", t_10, true);
if(frame.topLevel) {
context.setVariable("navigationId", t_10);
}
if(frame.topLevel) {
context.addExport("navigationId", t_10);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_11;
t_11 = "";
frame.set("navigationId", t_11, true);
if(frame.topLevel) {
context.setVariable("navigationId", t_11);
}
if(frame.topLevel) {
context.addExport("navigationId", t_11);
}
output += "\n    ";
;
}
output += "\n\n    ";
env.getTemplate("contentful/ugc-filters.j2", false, "core/templates/contentful/ugc-pdp-row-module-content.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
output += "\n\n    <div class=\"o-row c-ugc__content\">";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"items");
if(t_18) {var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("item", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += "\n\n            ";
output += "\n            ";
if((lineno = 20, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.tray.clickedTileIndex",-1])) == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index")) {
output += "\n\n                ";
var t_20;
t_20 = true;
frame.set("isClickedTile", t_20, true);
if(frame.topLevel) {
context.setVariable("isClickedTile", t_20);
}
if(frame.topLevel) {
context.addExport("isClickedTile", t_20);
}
output += "\n\n            ";
;
}
else {
output += "\n\n                ";
var t_21;
t_21 = false;
frame.set("isClickedTile", t_21, true);
if(frame.topLevel) {
context.setVariable("isClickedTile", t_21);
}
if(frame.topLevel) {
context.addExport("isClickedTile", t_21);
}
output += "\n\n            ";
;
}
output += "\n            ";
output += runtime.suppressValue((lineno = 31, colno = 27, runtime.callWrap(t_4, "displayUgcTile", context, [t_19,runtime.makeKeywordArgs({"tileTemplate": "TILE_WITH_HOVER","index": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"),"isClickedTile": runtime.contextOrFrameLookup(context, frame, "isClickedTile"),"displayHearts": runtime.contextOrFrameLookup(context, frame, "displayHearts"),"navigationId": runtime.contextOrFrameLookup(context, frame, "navigationId")})])), env.opts.autoescape);
output += "\n\n            ";
output += "\n            ";
if((lineno = 34, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["ugc.tray.trayTileIndex",-1])) == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index")) {
output += "\n\n                ";
env.getTemplate("contentful/ugc-tray.j2", false, "core/templates/contentful/ugc-pdp-row-module-content.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "\n\n            ";
})});
}
;
}
}
frame = frame.pop();
output += "</div>\n\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-pdp-row-module-content.j2"] , dependencies)